module.exports = __webpack_public_path__ + "static/img/product-list-active.417d519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/product-list-active.png
// module id = xvOR
// module chunks = 26